export function validatePassword(send) {
  return (tokenId, body, ...args) =>
    send(
      {
        path: '/v1/tokens/{tokenId}/password/validate',
        pathParameters: { tokenId },
        type: 'post',
        query: undefined,
        body: body,
        headers: undefined,
        auth: undefined,
        contentType: 'application/json',
      },
      ...args
    );
}
